import React, { Component } from "react";
import NavEN from "../Symbols/NavEN";
import FooterEN from "../Symbols/FooterEN";
import "../../stylesheets/Kontakt.css";
import { Helmet } from "react-helmet-async";

class KontaktEN extends Component {
  constructor(props) {
    super(props);
    this.intro = React.createRef();
    this.form_name = React.createRef();
    this.form_mail = React.createRef();
    this.form_comp = React.createRef();
    this.form_posi = React.createRef();
    this.form_country = React.createRef();
    this.form_msg = React.createRef();
    this.form_gdpr = React.createRef();
    this.form_tel = React.createRef();
    this.state = {
      error: false,
      success: false,
    };
  }

  introScroll = () => {
    let element = this.intro.current;
    let headerOffset = 45;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  sendMail = (e) => {
    if (
      !this.form_gdpr.current.checked ||
      !this.form_mail.current.value ||
      !this.form_name.current.value ||
      !this.form_comp.current.value ||
      !this.form_msg.current.value
    ) {
      this.setState({
        error: true,
      });
    } else {
      this.form_gdpr.current.checked = false;
      this.setState({
        error: false,
        success: true,
      });
      let html =
        "<h1>" +
        "Contact Form Submission Values<br><br>" +
        "</h1><p>Name: " +
        this.form_name.current.value +
        "</p>" +
        "<p>E-Mail: " +
        this.form_mail.current.value +
        "</p>" +
        "<p>Company: " +
        this.form_comp.current.value +
        "</p>" +
        "<p>Phone: " +
        this.form_tel.current.value +
        "</p>" +
        "<p>Position: " +
        this.form_posi.current.value +
        "</p>" +
        "<p>Country: " +
        this.form_country.current.value +
        "</p>" +
        "<p>Message: " +
        this.form_msg.current.value +
        "</p>";
      fetch("https://hooks.zapier.com/hooks/catch/7306825/bpqwmit/", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: JSON.stringify({ html }),
      });
      this.form_name.current.value = "";
      this.form_mail.current.value = "";
      this.form_comp.current.value = "";
      this.form_posi.current.value = "";
      this.form_country.current.value = "";
      this.form_msg.current.value = "";
      this.form_tel.current.value = "";
    }
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Contact</title>
          <meta
            name="description"
            content="Contact Pancon - your partner for high-quality
connection technologies. Our team supports purchasers and engineers with all
questions about products, solutions and projects. We look forward to your inquiry!"
          />
          <meta property="og:title" content="Pancon - Contact" />
          <meta
            property="og:description"
            content="Contact Pancon - your partner for high-quality
connection technologies. Our team supports purchasers and engineers with all
questions about products, solutions and projects. We look forward to your inquiry!"
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/kontakt"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/contact"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavEN />
        <div className="hero home">
          <div className="red-bg-hero"></div>
          <div className="hero-content">
            <h1 className="hero-heading">Contact</h1>
            <p className="hero-desc">We look forward to hearing from you!</p>
            <button onClick={this.introScroll} className="default inverted">
              Contact Form
            </button>
          </div>
        </div>
        <div
          ref={this.intro}
          className="section flex first intro center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2>Contact</h2>
            </div>
            <div>
              <p className="body">
                Get in touch with us.<br></br>You can reach our customer service
                her:{" "}
                <a
                  className="accented"
                  href="mailto:customer-service@pancon.de"
                >
                  customer-service@pancon.de
                </a>
              </p>
            </div>
            <div className="contact-cont flex">
              <div className="two-thirds flex">
                <div className="full">
                  <input
                    placeholder="Name"
                    className="i-half"
                    ref={this.form_name}
                  ></input>
                  <input
                    placeholder="E-Mail"
                    className="i-half"
                    ref={this.form_mail}
                  ></input>
                </div>
                <div className="full">
                  <input
                    placeholder="Company"
                    className="i-half"
                    ref={this.form_comp}
                  ></input>
                                    <input
                    placeholder="Phone"
                    className="i-half"
                    ref={this.form_tel}
                    type="tel"
                  ></input>
                </div>
                <div className="full">
                  <input
                    placeholder="Position"
                    className="i-half"
                    ref={this.form_posi}
                  ></input>
                  <input
                    placeholder="Country"
                    className="i-half"
                    ref={this.form_country}
                  ></input>
                </div>
                <div className="full">
                  <textarea
                    placeholder="Message"
                    className="i-full"
                    ref={this.form_msg}
                  ></textarea>
                </div>
                <label className="w-checkbox checkbox-cont flex row">
                  <input
                    ref={this.form_gdpr}
                    className="checkbox"
                    type="checkbox"
                  ></input>
                  <p className="checkbox-label">
                    I agree to this&nbsp;
                    <a
                      href="https://www.pancon.de/en/privacy-policy"
                      target={"_blank"}
                      className="accented"
                    >
                      Privacy Policy
                    </a>
                    .
                  </p>
                </label>
                {this.state.error ? (
                  <div className="full">
                    <p className="body error-msg">
                      Please enter at least your name, company, email address, a message and
                      agree to our privacy policy.
                    </p>
                  </div>
                ) : null}
                {this.state.success ? (
                  <div className="full">
                    <p className="body success-msg">
                      Your message was successfully delivered! Thank you!
                    </p>
                  </div>
                ) : null}
                <div className="full">
                  <button onClick={this.sendMail} className="default">
                    Submit
                  </button>
                </div>
              </div>
              <div className="third">
                <p className="body">
                  Pancon GmbH<br></br>
                  <br></br>Gesellschaft für elektromechanische Bauelemente
                  <br></br>Glücksteinallee 69<br></br>D-68163 Mannheim<br></br>Deutschland<br></br>
                  <br></br>E-Mail: info@pancon.de
                  <br></br>
                  <br></br>You can reach our Customer Service at the following
                  e-mail address:{" "}
                  <a
                    className="accented"
                    href="mailto:customer-service@pancon.de"
                  >
                    customer-service@pancon.de
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterEN />
      </div>
    );
  }
}

export default KontaktEN;
